import { MsalInterceptorConfiguration } from '@azure/msal-angular';
import { Configuration } from '@azure/msal-browser';
import { AppEnvironment, AppEnvironmentLabel } from 'src/app/models';
import { environment as base, sapZProxyUrl } from './environment.base';

const msalConfig: Configuration = {
  ...base.msalConfig,
  auth: {
    ...base.msalConfig.auth,
    redirectUri: 'https://emmet-qa.engineering.corp.lego.com',
    postLogoutRedirectUri: 'https://emmet-qa.engineering.corp.lego.com/logged-out',
  },
};

const msalInterceptorConfig: MsalInterceptorConfiguration = {
  ...base.msalInterceptorConfig,
  protectedResourceMap: new Map([
    [
      `${window.location.origin}/bom-header/*`,
      ['api://d17a9ded-b648-4861-867c-6f0cc30f696b/.default'],
    ],
    [
      `${window.location.origin}/bom-item/*`,
      ['api://d17a9ded-b648-4861-867c-6f0cc30f696b/.default'],
    ],
    [
      `${window.location.origin}/notification/*`,
      ['api://d17a9ded-b648-4861-867c-6f0cc30f696b/.default'],
    ],
    [
      `${window.location.origin}/notification-activity/*`,
      ['api://d17a9ded-b648-4861-867c-6f0cc30f696b/.default'],
    ],
    [
      `${window.location.origin}/material-data/*`,
      ['api://d17a9ded-b648-4861-867c-6f0cc30f696b/.default'],
    ],
    [
      `${window.location.origin}/project/*`,
      ['api://d17a9ded-b648-4861-867c-6f0cc30f696b/.default'],
    ],
    [
      `${window.location.origin}/equipment/*`,
      ['api://d17a9ded-b648-4861-867c-6f0cc30f696b/.default'],
    ],
    [`${window.location.origin}/api/*`, ['api://d17a9ded-b648-4861-867c-6f0cc30f696b/.default']],
    [`${window.location.origin}/proxy/*`, ['api://d17a9ded-b648-4861-867c-6f0cc30f696b/.default']],
  ]),
};

export const environment = {
  ...base,
  environmentName: AppEnvironment.QA,
  environmentLabel: AppEnvironmentLabel.QA,
  legoRestApiUrl: `https://dkatcpr-t1.corp.lego.com/LEGORESTAPI/rest/item/Z`,
  sapUrl: sapZProxyUrl,
  msalConfig,
  msalInterceptorConfig,
  teamcenter: 'https://tcsoa.tcplat-bll.prod.novus.internal.lego/workflow/v1/qa',
  optimizelySdkKey: 'Nw3AmDQW77kJ5xDaFgo9E',
};
